'use client';

import { ElementRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';
import { tokens } from '@/lib/design-tokens';

const labelVariants = cva(
  cn(
    tokens.typography.label,
    'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
  )
);

const Label = ({
  ref,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
  VariantProps<typeof labelVariants> & {
    ref?: React.RefObject<ElementRef<typeof LabelPrimitive.Root> | null>;
  }) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
);
Label.displayName = LabelPrimitive.Root.displayName || 'Label';

export { Label };
